<div class="padding-10">
    <div class="display-inline padding-right-10 notify-icon">
        <ng-container *ngIf="!isWarning && !isError">
            <i class="fa fa-lg fa-info-circle information-icon-color"></i>
        </ng-container>
        <ng-container *ngIf="isError">
            <span class="fa-stack fa-sm">
                <i class="fa fa-circle fa-stack-2x error-icon-color"></i>
                <i class="fa fa-times fa-stack-1x information-icon-color"></i>
            </span>
        </ng-container>

        <ng-container *ngIf="isWarning">
               <i class="fa fa-lg fa-exclamation-triangle warning-icon-color"></i>
        </ng-container>
    </div>
    <div class="display-inline notify-message">
        <span>{{data.message}}</span>
    </div>
    <div class="display-inline padding-left-20 notify-close">
        <i class="fas fa-times" (click)="closeNotifier()"></i>
    </div>
</div>